import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.scss';
import useAuth from '@hooks/useAuth';
import WhiteMyWishesCareLogo from '@assets/logos/MyWishes_Care_Logo2.svg';
import CareHomePartnerList from './components/CareHomePartnerList';

function Header() {
  const { logout, isLoggedIn } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="govuk-header" data-module="govuk-header">
      <div className="govuk-header__container govuk-width-container">
        <div className="govuk-header__logo" onClick={() => navigate('/')}>
          <img
            className="cursor-pointer"
            src={WhiteMyWishesCareLogo}
            alt="Mywhises White Logo"
            width={168}
          />
        </div>
        <div className="govuk-header__content govuk-!-width-two-thirds">
          <nav
            aria-label="Menu"
            className="govuk-header__navigation no-service-name"
          >
            <button
              type="button"
              className="govuk-header__menu-button govuk-js-header-toggle"
              aria-controls="navigation"
              aria-label="Show or hide menu"
              hidden
            >
              Services
            </button>
            <ul id="navigation" className="govuk-header__navigation-list">
              {!isLoggedIn ? (
                <div className="text-right">
                  <li className="govuk-header__navigation-item">
                    <a
                      target="_self"
                      title="Sign in to your account"
                      className="govuk-header__link"
                      href="/login"
                    >
                      Sign in
                    </a>
                  </li>
                </div>
              ) : (
                <div className="flex items-center justify-between">
                  <div>
                    <li className="govuk-header__navigation-item">
                      <CareHomePartnerList />
                    </li>
                  </div>
                  <div>
                    <li className="govuk-header__navigation-item">
                      <a
                        target="_self"
                        title="Team member"
                        className="govuk-header__link"
                        href="/invite"
                      >
                        Teams
                      </a>
                    </li>
                    <li className="govuk-header__navigation-item">
                      <a
                        target="_self"
                        title="Get help and support with your form"
                        className="govuk-header__link"
                        href="/contact"
                      >
                        Support
                      </a>
                    </li>
                    <li className="govuk-header__navigation-item">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        target="_self"
                        title="Sign out of your account"
                        className="govuk-header__link"
                        href="#"
                        onClick={e => {
                          e.preventDefault();
                          logout();
                        }}
                      >
                        Sign out
                      </a>
                    </li>
                  </div>
                </div>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
